import React, { useEffect } from 'react'
import styles from './style.module.scss'
import { useHistory, useLocation, useParams } from 'react-router'
import { SectionWrapper } from '@Root/HOCs'
import { CreateCourseRole } from './Create'
import { EditCourseRole } from './Edit'
import { useDispatch } from 'react-redux'
import { modalActions } from '@Root/store'
import { courseRoleActions } from '@Store/studies'
import { fieldTooltipManagerActions } from '@Store/fieldTooltipManager/index'

export const CourseRolePage = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const pathname = location.pathname
  const isNew = pathname.includes('new')
  const { studyProgrammeId } = useParams()
  const DEFAULT_URL = `/home/studies/programmes/${studyProgrammeId}/course_role`

  useEffect(() => {
    dispatch(courseRoleActions.getOptions())
    dispatch(fieldTooltipManagerActions.getDescriptions({ entity: 'studies', entity_type: 'programmes_course_role' }))
    return () => {
      dispatch(courseRoleActions.clearData())
    }
  }, [])

  const onOpenDescriptionModal = (description, title) => {
    new Promise((resolve, reject) => {
      dispatch(
        modalActions.showModal('NotificationModal', {
          text: description,
          clickRejectButtonHandler: reject,
          clickResolveButtonHandler: resolve,
          title,
        })
      )
    }).finally(() => dispatch(modalActions.hideModal()))
  }
  return (
    <SectionWrapper hasBackButton backButtonText={'Course Role Details'} clickBackButtonHandler={() => history.push(DEFAULT_URL)}>
      <div className={styles.sections}>
        {isNew ? (
          <CreateCourseRole onOpenDescriptionModal={onOpenDescriptionModal} parentURL={DEFAULT_URL} />
        ) : (
          <EditCourseRole onOpenDescriptionModal={onOpenDescriptionModal} />
        )}
      </div>
    </SectionWrapper>
  )
}
